import {S3Client, PutObjectCommand, DeleteObjectCommand} from '@aws-sdk/client-s3';

const s3c = new S3Client({
    forcePathStyle: true,
    region: 'eu-central-1',
    endpoint: 'https://agzgtvopyggthwhdvjww.supabase.co/storage/v1/s3',
    credentials: {
        accessKeyId: '58011a4e25089d0e6cc13db6d9e02e65',
        secretAccessKey: '4fd79df2f1ba332215371f6e0efe885157f6f293ccba0bebff1a2f74674a3872',
    }
})

export async function uploadImageToS3(base64Image, bucketName, fileName) {
    // Prevedieme Base64 reťazec späť na binárne dáta
    const byteString = atob(base64Image.replace(/^data:image\/\w+;base64,/, ''));

    // Vytvoríme ArrayBuffer a následne Uint8Array na prevod binárnych dát
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
    }

    // Určíme MIME typ obrázka
    const mimeType = base64Image.match(/^data:(image\/\w+);base64,/)[1];

    // Pripravíme objekt pre upload
    const params = {
        Bucket: bucketName,
        Key: fileName,
        Body: uintArray,
        ContentEncoding: 'base64', // potrebné, ak ukladáš Base64
        ContentType: mimeType // typ obsahu, napríklad image/jpeg, image/png
    };

    try {
        // Nahrávanie na S3
        const data = await s3c.send(new PutObjectCommand(params));
        return true;
    } catch (err) {
        console.error('Chyba pri nahrávaní:', err);
        return false;
    }
}


export async function deleteImageFromS3(bucketName, fileName) {
    const params = {
        Bucket: bucketName,
        Key: fileName
    };

    try {
        const data = await s3c.send(new DeleteObjectCommand(params));
        console.log('Obrázok úspešne zmazaný:', data);
        return true;
    } catch (err) {
        console.error('Chyba pri mazaní:', err);
        return false;
    }
}
